import React from "react"

const Error = () => {
    return <div>404页面不存在</div>
}

export default Error
